import React, { useState,useRef, useEffect } from 'react'
import IdleTimer from 'react-idle-timer'
import { useHistory } from "react-router-dom";
import { Modal, Button} from "react-bootstrap";
import Axios from 'axios';
import {NODE_API_URL} from "./../env_config"
import { makeStyles } from '@material-ui/core';

function IdleTimerContainer({themeData}) {

    const useStyle = makeStyles((theme) => ({
        endBtn: {
            backgroundColor: themeData?.background_color ? `${themeData?.background_color} !important` : "#FFA800 !important",
            borderColor: themeData?.background_color ? `${themeData?.background_color} !important` : "#FFA800 !important",
        }
    }));

    const classes = useStyle();

    const history = useHistory();
    const id = React.useMemo(()=>localStorage.getItem("C_id"),[])
    const consumerSessionId = React.useMemo(()=>JSON.parse(localStorage.getItem("consumerSessionId")),[])
    const [show, setShow] = React.useState(false);
    const [countdown, setCounterdown] = useState();
    const idelTimerRef = useRef(null);

    function handleClose(event, reason) {
        setShow(false)
    }

    const onIdle = () => {
        localStorage.clear();
        window.location.reload(true)
        
    }

    var timer = useRef();
    const sessionOut = () => {
       if( id === "-1" || id === "-2" || id === "") {
            setShow(false)
        } else {
            setShow(true)
            setCounterdown(30)
            timer.current = setInterval(() => setCounterdown(prev => prev - 1), 1000);
            return () => clearInterval(timer.current);
        }
    }   

    const sessionExpire = () => {
        // end consumer session
        if(consumerSessionId && consumerSessionId > 0){
            Axios({
            method: "POST",
            url: `${NODE_API_URL}/ccmode/ccmode-end-session`,
            headers: {
                "Access-Control-Allow-Origin": "*",
                "Content-Type": "application/json",
                "Authorization": `Bearer ${localStorage.getItem("accessToken")}`
            },
            data: {
                consumerSessionId: consumerSessionId,
                closeAction: "Session Expired",
            },
            }).then(res => {
            if(res.data.message === "UnAuthorized"){
                localStorage.clear();
                window.location.reload(true)
            }
            }).catch(err => {
            
            })
        }

        window.localStorage.setItem("C_id", -1)
            setShow(false)
            setTimeout(() => {
                setTimeout(() => {
                    window.location.reload(true)
                }, 100);
                history.push({  pathname: '/searchdiamond'})
            }, 500);
     }  

    useEffect(() => {
        if(countdown <= 0 && (id !== "-1" || id !== "-2" || id !== "" ) && show === true){
            clearInterval(timer.current);
            sessionExpire()
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    },[countdown]);

    return (
        <div>
            <Modal
                show={show}
                onHide={handleClose}
                backdrop="static"
                keyboard={false}
                size="md"
            >
                <Modal.Header closeButton>
                    <Modal.Title>Warning !</Modal.Title>
                </Modal.Header>
                <Modal.Body className="text-center">
                    <div className="row">
                       <div className='col-12 mb-5'> <h6>You've been idle for a while</h6></div >
                        <div className='col-12'>
                            <button className={`btn btn-warning mr-4 btn-square ${classes.endBtn}`} onClick={sessionExpire}>End Sesssion ( 00 : {countdown} )</button>     
                            <button className="btn btn-success btn-square" onClick={handleClose}>I'm here</button>
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button
                        variant="secondary"
                        onClick={handleClose}
                    >
                        Close
                    </Button>
                </Modal.Footer>
            </Modal>
            <IdleTimer
                ref={idelTimerRef}
                // timeout={12 * 100000} // 20 minuts
                timeout={12 * 3600000} // 60 minuts
                onIdle={onIdle}>
            </IdleTimer>
            <IdleTimer
                ref={idelTimerRef}
                timeout={9 * 100000} // 15 minuts
                // timeout={6 * 100000} // 10 minuts
                onIdle={sessionOut}>
            </IdleTimer>
        </div>
    )
}
export default IdleTimerContainer;